module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加选配")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "optionalForm",
    attrs: {
      "label-width": "150px",
      "model": _vm.optionalForm,
      "rules": _vm.addOptionalRules
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("选配基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配名称",
      "label-width": "150px",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.name),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "name", $$v)
      },
      expression: "optionalForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "accessoryType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.optionalForm.accessoryType),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "accessoryType", $$v)
      },
      expression: "optionalForm.accessoryType"
    }
  }, [_vm._v("按次算")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.optionalForm.accessoryType),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "accessoryType", $$v)
      },
      expression: "optionalForm.accessoryType"
    }
  }, [_vm._v("按天算")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格(单位：分)",
      "label-width": "150px",
      "prop": "rental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.rental),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "rental", $$v)
      },
      expression: "optionalForm.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配押金(单位：分)",
      "label-width": "150px",
      "prop": "deposit"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionalForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "deposit", $$v)
      },
      expression: "optionalForm.deposit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.optionalForm.description),
      callback: function($$v) {
        _vm.$set(_vm.optionalForm, "description", $$v)
      },
      expression: "optionalForm.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce16706a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/AddOptional.vue
// module id = 754
// module chunks = 1